//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/assets/css/reset.css";
import "@/assets/css/global.css";
export default {
  components: {},
  data() {
    return {
      // scanConfig: {
      //   btnL: {text: '返回', action: () => this.$router.go(-1)},
      //   desc: '扫一扫急速入库'
      // }
      isScanShow: true
    };
  },
  props: ["config"],
  computed: {
    arrowDownPanelClass() {
      switch (this.isScanShow) {
        case true:
          return "transition-slide-in";
        case false:
          return "transition-slide-out";
      }
    },
    arrowUpPanelClass() {
      switch (this.isScanShow) {
        case true:
          return "transition-slide-out";
        case false:
          return "transition-slide-in";
      }
    }
  },
  methods: {

    $getActionObj(){

      var actionObj = this.$parent.$getActionObj();
      return actionObj;
    },

    $getSubmitData(){

      var postData = null;
      try{
        postData = this.$parent.$getSubmitData();
        //console.log("postData",postData);
      }catch(e){
        console.log("getSubmitData=====e",e);
      }
      return postData;
    },


    scanCode() {
      wx.scanCode({
        success: res => {
          console.log("扫码结果");
          this.$emit("scanCode",res.result)
          this.scanCode()
        },
        fail: res => {
          console.log(res);
        }
      });
    },
    switchScan() {
      this.isScanShow = !this.isScanShow;
    },
    onUnload() {
      this.isScanShow = true;
    },
    onScanCodeClick(){
      console.log("开始扫码")
      this.config.btnScanCode.action();
    },

    async onButtonClick(buttonItem) {

      if (!buttonItem) {
        return;
      }
      var actionObj = this.$getActionObj();
      await this.$cmd.ExecuteCmd(buttonItem,actionObj);

    },
  },
  
};
